module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "viewBox": "0 0 16 16",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "preserveaspectratio": ""
    }
  }, [_c('line', {
    attrs: {
      "x1": "0",
      "y1": "0%",
      "x2": "100%",
      "y2": "100%",
      "stroke": "currentColor",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "100%",
      "x2": "100%",
      "y2": "0%",
      "stroke": "currentColor",
      "stroke-width": "1"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-363fdbe3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconClose.vue
// module id = 379
// module chunks = 1